// /opt/isp_erp/frontend/src/pages/admin/clientes/ClienteDetalle.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../../api/axios";

// Subcomponentes
import DatosGenerales from "./components/DatosGenerales";
import PagosCliente from "./components/PagosCliente";
import FacturacionCliente from "./components/FacturacionCliente";
import TicketsCliente from "./components/TicketsCliente";
import OnuCliente from "./components/OnuCliente";
import NapCliente from "./components/NapCliente";
import CorteCliente from "./components/CorteCliente";
import ONUStatusButton from "../../../components/ONUStatusButton";
import "./ClienteDetalle.css";
import "./ClienteDetalle.pro.css";

export default function ClienteDetalle() {
  const { customerId } = useParams();
  const navigate = useNavigate();
  const [cliente, setCliente] = useState(null);
  const [onu, setOnu] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("datos");

  const fetchCliente = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/customers/${customerId}`);
      setCliente(response.data);

      // Si tiene ONU asignada, cargar sus datos
      if (response.data.onu_id) {
        const onuResponse = await axios.get(`/olts/onus/${response.data.onu_id}`);
        setOnu(onuResponse.data);
      }
    } catch (error) {
      console.error("Error cargando cliente:", error);
      alert("Error al cargar datos del cliente");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCliente();
  }, [customerId]);

  const handleClienteActualizado = () => {
    fetchCliente();
  };

  const handleOnuStatusChange = (newStatus) => {
    // Actualizar el estado local de la ONU
    setOnu(prev => ({
      ...prev,
      admin_state: newStatus === 'active' ? 'up' : 'down'
    }));
  };

  const getEstadoClass = (estado) => {
    const classes = {
      'ACTIVO': 'estado-activo',
      'SUSPENDIDO': 'estado-suspendido',
      'RETIRADO': 'estado-retirado',
      'PENDIENTE_INSTALACION': 'estado-pendiente_instalacion'
    };
    return classes[estado] || '';
  };

  if (loading) {
    return (
      <div className="detalle-loading-container">
        <div className="detalle-loading-spinner"></div>
        <p>Cargando datos del cliente...</p>
      </div>
    );
  }

  if (!cliente) {
    return (
      <div className="detalle-error-container">
        <div className="detalle-error-card">
          <div className="detalle-error-icon">❌</div>
          <p className="detalle-error-title">Cliente no encontrado</p>
          <button
            onClick={() => navigate("/clientes/usuarios")}
            className="detalle-btn-primary"
          >
            Volver a Clientes
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="cliente-detalle detalle-pro">
      {/* Cabecera con información del cliente */}
      <div className="detalle-header">
        <div className="detalle-header-left">
          <div className="detalle-avatar">
            {cliente.nombres?.charAt(0) || '👤'}
          </div>
          <div className="detalle-info">
            <h1>{cliente.nombres} {cliente.apellidos}</h1>
            <div className="detalle-meta">
              <span className="detalle-id">{cliente.tipo_identificacion || 'CEDULA'}: {cliente.identificacion || 'sin registrar'}</span>
              <span className="detalle-id">#{cliente.id}</span>
              <span className={`detalle-estado ${getEstadoClass(cliente.estado)}`}>
                {cliente.estado === 'ACTIVO' && '✅ '}
                {cliente.estado === 'SUSPENDIDO' && '⏸️ '}
                {cliente.estado === 'RETIRADO' && '📦 '}
                {cliente.estado === 'PENDIENTE_INSTALACION' && '🛠️ '}
                {cliente.estado === 'PENDIENTE_INSTALACION' ? 'PENDIENTE DE INSTALACIÓN' : cliente.estado}
              </span>
            </div>
          </div>
        </div>

        <div className="detalle-header-actions">
          {/* Botón de estado de ONU - Solo si tiene ONU asignada */}
          {cliente.onu_id && (
            <ONUStatusButton
              onuId={cliente.onu_id}
              currentStatus={
                onu?.admin_state === 'up' ? 'active' :
                onu?.admin_state === 'down' ? 'suspended' :
                cliente.estado === 'ACTIVO' ? 'active' : 'suspended'
              }
              onStatusChange={handleOnuStatusChange}
            />
          )}
          <button
            onClick={() => navigate("/clientes/usuarios")}
            className="detalle-btn-secondary"
          >
            ← Volver
          </button>
        </div>
      </div>

      {/* Tabs de navegación */}
      <div className="detalle-tabs">
        <button
          onClick={() => setActiveTab("datos")}
          className={`detalle-tab ${activeTab === "datos" ? "active" : ""}`}
        >
          <span className="tab-icon">👤</span>
          Datos Generales
        </button>
        <button
          onClick={() => setActiveTab("pagos")}
          className={`detalle-tab ${activeTab === "pagos" ? "active" : ""}`}
        >
          <span className="tab-icon">💰</span>
          Pagos
        </button>
        <button
          onClick={() => setActiveTab("facturas")}
          className={`detalle-tab ${activeTab === "facturas" ? "active" : ""}`}
        >
          <span className="tab-icon">📄</span>
          Facturación
        </button>
        <button
          onClick={() => setActiveTab("tickets")}
          className={`detalle-tab ${activeTab === "tickets" ? "active" : ""}`}
        >
          <span className="tab-icon">🎫</span>
          Tickets/Soportes
        </button>
        <button
          onClick={() => setActiveTab("onu")}
          className={`detalle-tab ${activeTab === "onu" ? "active" : ""}`}
        >
          <span className="tab-icon">📡</span>
          ONU Asignada
        </button>
        {/* 👈 NUEVA PESTAÑA PARA NAP */}
        <button
          onClick={() => setActiveTab("nap")}
          className={`detalle-tab ${activeTab === "nap" ? "active" : ""}`}
        >
          <span className="tab-icon">🗄️</span>
          Conexión NAP
        </button>
        <button
          onClick={() => setActiveTab("corte")}
          className={`detalle-tab ${activeTab === "corte" ? "active" : ""}`}
        >
          <span className="tab-icon">⏰</span>
          Corte
        </button>
      </div>

      {/* Contenido según tab */}
      <div className="detalle-contenido">
        {activeTab === "datos" && (
          <DatosGenerales cliente={cliente} onActualizacion={handleClienteActualizado} />
        )}

        {activeTab === "pagos" && (
          <PagosCliente customerId={customerId} />
        )}

        {activeTab === "facturas" && (
          <FacturacionCliente customerId={customerId} />
        )}

        {activeTab === "tickets" && (
          <TicketsCliente customerId={customerId} />
        )}

        {activeTab === "onu" && (
          <OnuCliente
            customerId={parseInt(customerId)}
            onuId={cliente.onu_id}
            onActualizacion={handleClienteActualizado}
          />
        )}

        {/* 👈 NUEVO CONTENIDO PARA NAP */}
        {activeTab === "nap" && (
          <NapCliente customerId={parseInt(customerId)} />
        )}

        {activeTab === "corte" && (
          <CorteCliente customerId={parseInt(customerId)} />
        )}

      </div>
    </div>
  );
}
